import { EventCallbackResult } from 'tracking/types';

export const getEventProcessingStatus = (tags: EventCallbackResult['tags']) => {
  if (!tags) {
    return 'unknown';
  }
  if (tags.every((tag) => tag.status === 'success')) {
    return 'success';
  }
  if (tags.every((tag) => tag.status === 'failure')) {
    return 'failure';
  }
  return 'partial';
};
